import MenuItem from "../../../types/menu/MenuItem";

const AGSNavList: MenuItem[] = [
  {
    id: 1,
    name: 'contactInfo',
    componentName: 'ContactInfo',
    complete: false
  },
  {
    id: 2,
    name: 'propertyDetails',
    componentName: 'PropertyDetails',
    complete: false
  },
  {
    id: 3,
    name: 'licensedLands',
    componentName: 'LicensedLands',
    complete: false
  },
  {
    id: 4,
    name: 'licensedPonds',
    componentName: 'LicensedPonds',
    complete: false
  },
  {
    id: 5,
    name: 'unlicensedLands',
    componentName: 'UnlicensedLands',
    complete: false
  },
  {
    id: 6,
    name: 'comments',
    componentName: 'Comment',
    complete: false
  },
  {
    id: 7,
    name: 'documents',
    componentName: 'AggregateFileUpload',
    complete: false
  },
  {
    id: 8,
    name: 'agsSummary',
    componentName: 'AGSSummary',
    complete: false
  },
  {
    id: 9,
    name: 'submit',
    componentName: 'Submit',
    complete: false
  },
];

export default AGSNavList;
